<template>
  <div class="gatherPage">
    <van-pull-refresh v-model="isRefreshLoading" @refresh="onRefresh">
      <p class="paddingH"></p>
      <div class="headerTotal">
        <van-row type="flex" justify="space-around">
          <van-col span="7" class="totalLi">
            <p>今日巡林(次)</p>
            <p class="totalP">{{ todayNum ? todayNum : "" }}</p>
            <van-image class="xunlinDay" :src="baseUrl + 'xlsyDay.png'" />
          </van-col>
          <van-col span="7" class="totalLi">
            <p>本月巡林(次)</p>
            <p class="totalP">{{ currentMonNum ? currentMonNum : "" }}</p>
            <van-image class="xunlinMonth" :src="baseUrl + 'xlsyMonth.png'"
          /></van-col>
          <van-col span="7" class="totalLi">
            <p>年度巡林(次)</p>
            <p class="totalP">{{ currentYearNum ? currentYearNum : "" }}</p>
            <van-image class="xunlinYear" :src="baseUrl + 'xlsyYear.png'"
          /></van-col>
        </van-row>
      </div>
      <p class="fgx"></p>
      <div class="eChartBox">
        <p class="eChartTit ggTit">巡林趋势图</p>
        <van-tabs v-model="activeEchart" class="echartTabs ggTabs">
          <van-tab title="7日" name="echartDay"> </van-tab>
          <van-tab title="月度" name="echartMonth"> </van-tab>
          <van-tab title="年度" name="echartYear"> </van-tab>
        </van-tabs>
        <xun-lin-echart :echartActive="activeEchart"></xun-lin-echart>
      </div>
      <p class="fgx"></p>
      <div class="rankingListBox">
        <p class="rankingTit ggTit">巡林排行榜</p>
        <van-tabs v-model="activeRanking" class="rankingTabs ggTabs">
          <van-tab title="本日" name="rankingDay"></van-tab>
          <van-tab title="本月" name="rankingMonth"></van-tab>
          <van-tab title="本年" name="rankingYear"></van-tab>
        </van-tabs>
        <div class="rankingMian">
          <!-- 巡林排行榜组件 -->
          <ranking-list
            :rankingTypeActive="activeRanking"
            :listType="allRankingList"
          ></ranking-list>
        </div>
      </div>
      <p class="fgx"></p>
      <div class="RecordBox">
        <p class="rankingTit ggTit">巡林记录</p>
        <div class="recordMain">
          <record-list></record-list>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
const xunLinEchart = () => import("@/views/xunlin/components/xunLinEchart");
const rankingList = () => import("@/views/xunlin/components/rankingList");
const recordList = () => import("@/views/xunlin/components/xunLRecord");
export default {
  name: "gatherPage",
  components: {
    xunLinEchart,
    rankingList,
    recordList,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      isRefreshLoading: false, //下拉刷新
      activeEchart: "echartDay",
      activeRanking: "rankingDay",
      allRankingList: false, //巡林排行榜是否显示全部
      currentMonNum: "", //本月巡林
      currentYearNum: "", //年度巡林
      todayNum: "", //今日巡林
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    document.title = "巡林数据";
    this.getHeaderTotal();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        // this.$toast("刷新成功");
        this.isRefreshLoading = false;
        if (this.clientType == "android") {
          //android
          window.android.getInfo(122);
        } else {
          //IOS
          window.webkit.messageHandlers.getRefreshPage.postMessage("1");
        }
      }, 1000);
    },

    getHeaderTotal() {
      let _this = this;
      _this.$api.xunLData
        .getXunLStatistics()
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.currentMonNum = res.data.currentMonNum; //本月巡林
            _this.currentYearNum = res.data.currentYearNum; //年度巡林
            _this.todayNum = res.data.todayNum; //今日巡林
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less">
.gatherPage {
  width: 100%;

  font-family: "PingFangSC-Regular", "PingFang SC";
  color: #333;
  .paddingH {
    width: 100%;
    height: 15px;
  }
  .fgx {
    width: 100%;
    height: 12px;
    background-color: #f1f1f1;
  }
  .headerTotal {
    .totalLi {
      height: 65px;
      display: block;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
      border-radius: 8px;
      padding: 12px 0 0 12px;
      position: relative;
      p {
        font-size: 12px;
        color: #868686;
      }
      p.totalP {
        margin-top: 6px;
        font-size: 22px;
        color: #000;
      }
      .xunlinDay {
        width: 11px;
        height: 17px;
        position: absolute;
        right: 12px;
        bottom: 12px;
      }
       .xunlinMonth {
        width: 14px;
        height: 17px;
        position: absolute;
        right: 12px;
        bottom: 12px;
      }
       .xunlinYear {
        width: 18px;
        height: 17px;
        position: absolute;
        right: 12px;
        bottom: 12px;
      }
    }
  }
  .eChartBox,
  .rankingListBox,
  .RecordBox {
    position: relative;
  }
  .ggTit {
    position: absolute;
    top: 14px;
    left: 16px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    line-height: 22px;
  }
  .ggTabs {
    .van-tabs__wrap {
      width: 100%;
      .van-tabs__nav {
        width: 130px;
        float: right;
        padding-bottom: 8px;
        .van-tab {
          color: #8b8b8b;
        }
        .van-tab.van-tab--active {
          color: #0ab889;
        }
      }
      .van-tabs__line {
        background-color: #0ab889;
        width: 22px;
      }
    }
    .van-tabs__wrap.van-hairline--top-bottom::after {
      content: none;
    }
  }
  .eChartBox,
  .rankingListBox,
  .RecordBox {
    width: 100%;
    background-color: #fff;
    .echartTabs,
    .rankingTabs {
      width: 100%;
      padding: 0 16px;
    }
  }
  .rankingListBox {
    .rankingMian {
      margin-top: 16px;
      > .xunLinRankingPage {
        .TabsList {
          width: 100%;
          min-height: 140px;
          position: relative;
        }
      }
    }
  }
  .RecordBox {
    min-height: 300px;
    padding-top: 45px;
  }
}
</style>